<day-selector
  class="mb-4"
  [startDate]="defaultStartDay"
  [stickyToday]="false"
  [maxNumberOfDaysToShow]="7"
  (onDaySelected)="onDaySelected($event)"
  [showOnlyDayNames]="true"
></day-selector>

<serie-proposal-schedule
  [serieProposals]="serieProposals"
  [selectedProductIds]="targetedProductsIds$ | async"
  (onClickSerieProposal)="onClickEvent($event)"
  [selectedDay]="selectedDay"
  [dependantProductsMap]="dependantProductsMap"
>
</serie-proposal-schedule>
<div class="mb-2">
  <span class="me-3">
    <span class="serie-proposal-requested badge"
      ><i role="img" class="fa fa-clock small" aria-hidden="true"></i
    ></span>
    {{ 'serieProposalModule.requested' | translate }}
  </span>

  <span class="me-3">
    <span class="serie-proposal-accepted badge"
      ><i role="img" class="fa fa-check" aria-hidden="true"></i
    ></span>
    {{ 'serieProposalModule.accepted' | translate }}
  </span>

  <span class="me-3">
    <span class="serie-proposal-conflict badge"
      ><i role="img" class="fa fa-exclamation-triangle" aria-hidden="true"></i
    ></span>
    {{ 'serieProposalModule.conflict' | translate }}
  </span>

  <span class="me-3">
    <span class="serie-proposal-counter-proposal badge"
      ><i role="img" class="fa fa-sync-alt" aria-hidden="true"></i
    ></span>
    {{ 'serieProposalModule.counterProposal' | translate }}
  </span>

  <span class="me-3">
    <span class="bg-gray badge"
      ><i
        role="img"
        class="fa fa-times-circle text-black"
        aria-hidden="true"
      ></i
    ></span>
    {{ 'serieProposalModule.declined' | translate }}
  </span>

  <span class="me-3">
    <span class="bg-light dependant-product-style badge"
      ><i role="img" class="fa fa-link text-black" aria-hidden="true"></i
    ></span>
    {{ 'productModule.dependantProducts' | translate }}
  </span>
  <span class="me-3">
    <span class="hours-disabled badge"
      ><i role="img" class="fa fa-ban text-black" aria-hidden="true"></i
    ></span>
    {{ 'general.unavailable' | translate }}
  </span>
</div>
